import { render } from "./PDFViewer.vue?vue&type=template&id=c0beb6e0&scoped=true&ts=true"
import script from "./PDFViewer.vue?vue&type=script&lang=ts"
export * from "./PDFViewer.vue?vue&type=script&lang=ts"

import "./PDFViewer.vue?vue&type=style&index=0&id=c0beb6e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0beb6e0"]])

export default __exports__